const ROLE_ZH: Record<string, string> = {
  admin: "管理员",
  user: "普通用户",
};

export function roleLabelZh(role: string): string {
  return ROLE_ZH[role] ?? role;
}

export function userStatusLedgerTag(status: string): "success" | "pending" | "error" {
  const s = status.toLowerCase();
  if (s === "active") return "success";
  if (s === "blocked") return "error";
  return "pending";
}

export function userStatusLedgerText(status: string): string {
  const t = userStatusLedgerTag(status);
  if (t === "success") return "SUCCESS";
  if (t === "error") return "ERROR";
  return "PENDING";
}
